import { Autocomplete } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const CustomAutocomplete = (props: any) => {
  const { t } = useTranslation();
  return <Autocomplete noOptionsText={t('No options')} {...props} />;
};
